import { useState, useEffect } from 'react';
import apiUser from '../../apiUser';
import LoadingSpinner from '../Loader/load';

const compAnterior = () => {
    const d = new Date(); d.setMonth(d.getMonth() - 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};
const fmtData = (v) => (v ? new Date(v).toLocaleString('pt-BR') : '—');

const Spxo = () => {
    const [status, setStatus] = useState(null);
    const [circuitos, setCircuitos] = useState([]);
    const [competencia, setCompetencia] = useState(compAnterior());
    const [clienteSync, setClienteSync] = useState('');
    const [sincronizando, setSincronizando] = useState(false);
    const [loading, setLoading] = useState(true);

    const carregar = async () => {
        setLoading(true);
        try {
            const [s, c] = await Promise.all([
                apiUser.get('/faturamento/spxo/status'),
                apiUser.get('/faturamento/spxo/circuitos'),
            ]);
            if (s.data.success) setStatus(s.data);
            if (c.data.success) setCircuitos(c.data.dados);
        } finally { setLoading(false); }
    };
    useEffect(() => { carregar(); }, []);

    const sincronizar = async () => {
        setSincronizando(true);
        try {
            const payload = { competencia };
            if (clienteSync) payload.cliente = clienteSync;
            const { data } = await apiUser.post('/faturamento/spxo/sincronizar', payload);
            if (data.success) {
                alert(data.id_cliente
                    ? `Sincronização de ${String(data.competencia).slice(0, 7)} do cliente selecionado iniciada — só os circuitos dele (rápida).`
                    : `Sincronização COMPLETA de ${String(data.competencia).slice(0, 7)} iniciada em segundo plano — pode levar até ~1h (pagina todas as chamadas do mês). Acompanhe em "Última sync".`);
                carregar();
            } else alert(data.message || 'Falha na sincronização.');
        } finally { setSincronizando(false); }
    };

    if (loading) return <LoadingSpinner />;
    const emAndamento = status?.sync_em_andamento;
    const semCliente = circuitos.filter((c) => !c.id_cliente);
    return (
        <div className='p-4 space-y-4'>
            <div className='flex flex-wrap items-end gap-3'>
                <div>
                    <label className='block text-sm text-gray-600 dark:text-gray-300'>Competência</label>
                    <input type='month' className='border rounded p-2 dark:bg-gray-700'
                        value={competencia.slice(0, 7)}
                        onChange={(e) => setCompetencia(`${e.target.value}-01`)} />
                </div>
                <div>
                    <label className='block text-sm text-gray-600 dark:text-gray-300'>Cliente (opcional — só ele)</label>
                    <select className='border rounded p-2 dark:bg-gray-700 max-w-xs' value={clienteSync}
                        onChange={(e) => setClienteSync(e.target.value)}>
                        <option value=''>Todos (sync completo)</option>
                        {[...new Map(circuitos.filter((c) => c.id_cliente)
                            .map((c) => [c.id_cliente, c.cliente_nome])).entries()]
                            .sort((a, b) => String(a[1]).localeCompare(String(b[1])))
                            .map(([id, nome]) => <option key={id} value={id}>{nome}</option>)}
                    </select>
                </div>
                <button onClick={sincronizar} disabled={sincronizando || !!emAndamento}
                    className='bg-blue-600 text-white rounded px-3 py-2 disabled:opacity-50'>
                    {emAndamento ? `Sincronizando ${String(emAndamento.competencia).slice(0, 7)}…` : sincronizando ? 'Iniciando…' : clienteSync ? 'Sincronizar cliente' : 'Sincronizar SPXO'}
                </button>
                {emAndamento && (
                    <button onClick={carregar} className='border rounded px-3 py-2 text-sm'>Atualizar status</button>
                )}
                <div className='ml-auto text-sm text-gray-600 dark:text-gray-300'>
                    Modo: <b>{status?.modo || 'não configurado'}</b> ·
                    Circuitos: <b>{status?.dados?.circuitos || 0}</b> (casados: <b>{Number(status?.dados?.casados) || 0}</b>) ·
                    Última sync: <b>{fmtData(status?.dados?.ultima_sync)}</b>
                </div>
            </div>

            {(status?.dados?.competencias || []).length > 0 && (
                <div className='text-sm text-gray-600 dark:text-gray-300'>
                    Competências sincronizadas: {status.dados.competencias.map((c) =>
                        `${String(c.competencia).slice(0, 7)} (${c.metricas} métricas)`).join(' · ')}
                </div>
            )}

            {semCliente.length > 0 && (
                <p className='bg-yellow-50 border border-yellow-300 rounded-lg p-3 text-yellow-900 text-sm'>
                    ⚠ {semCliente.length} circuito(s) sem cliente ERP (CNPJ não casou) — confira o CNPJ no cadastro do cliente ou na SaperX.
                </p>
            )}

            <table className='w-full text-sm'>
                <thead><tr className='text-left border-b'>
                    <th className='py-2'>Circuito</th><th>id_sip</th><th>cod_cli</th><th>CNPJ</th><th>Cliente ERP</th><th>Ativo</th>
                </tr></thead>
                <tbody>
                    {circuitos.map((c) => (
                        <tr key={c.id_sip} className={`border-b ${!c.id_cliente ? 'bg-yellow-50 dark:bg-yellow-900/20' : ''}`}>
                            <td className='py-1.5'>{c.nome}</td>
                            <td>{c.id_sip}</td>
                            <td>{c.cod_cli || '—'}</td>
                            <td>{c.cnpj || '—'}</td>
                            <td>{c.cliente_nome || <span className='text-yellow-700'>não casou</span>}</td>
                            <td>{c.active === 1 ? 'sim' : c.active === 3 ? 'cancelado' : c.active}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Spxo;
